// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"no-result"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M8.12602 14H2V21H22V14H15.874C15.4299 15.7252 13.8638 17 12 17C10.1362 17 8.57006 15.7252 8.12602 14Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2.5 14H8.12602C8.57006 15.7252 10.1362 17 12 17C13.8638 17 15.4299 15.7252 15.874 14H21.5M22 21H2V14L6 7H18L22 14V21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6.50098 3.5L5.00098 2M17.499 3.5L18.999 2M12 3V1","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-no-result')
export default class NoResultIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'no-result',
    }
  }
}
